export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8542.c1749cd1.jpg";